import { render, staticRenderFns } from "./add-customer-account.vue?vue&type=template&id=7f681c50&scoped=true&"
import script from "./add-customer-account.vue?vue&type=script&lang=js&"
export * from "./add-customer-account.vue?vue&type=script&lang=js&"
import style0 from "./add-customer-account.vue?vue&type=style&index=0&id=7f681c50&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f681c50",
  null
  
)

export default component.exports